import React, { useEffect } from "react";
import { isEmpty } from "lodash";
import { Paper } from "@material-ui/core";
import { CustomerContactPersonFragment, useGetAttestContactPersonsQuery } from "@graphql";
import { Body, ErrorCard, Spinner } from "@components";
import CustomerContactCard from "@customers/CustomerContactPersons/CustomerContactCard";
import { useSnackbars } from "@hooks";

type Props = {
  areaOfExpertise: string;
  hospitalId: string;
  departmentIds: string[];
  onFetch?: (v: CustomerContactPersonFragment[]) => void;
};

export function BookingContactPerson(props: Props) {
  const snack = useSnackbars();
  const { areaOfExpertise, hospitalId, departmentIds, onFetch } = props;

  const query = useGetAttestContactPersonsQuery({
    variables: { hospitalId, departmentIds, areaOfExpertise },
    fetchPolicy: "network-only",
    onError: () => snack.showError(`cannot load contact persons`)
  });

  useEffect(() => {
    onFetch(query.data?.attestContactPersons?.items ?? []);
  }, [query.data]);

  if (query.error) {
    return <ErrorCard message="Cannot load contact persons" title="Error" />;
  }

  if (query.loading) {
    return <Spinner size={16} inline style={{ marginLeft: 8 }} />;
  }

  if (isEmpty(query.data?.attestContactPersons)) {
    return (
      <div>
        <Body block color="textSecondary" style={{ fontSize: "1rem" }}>
          Kontaktpersoner
        </Body>
        <Body block style={{ marginTop: 4 }} color="error">
          Saknar ansvarig attestperson. Detta måste läggas till innan första veckan
          tidrapporteras
        </Body>
      </div>
    );
  }

  return (
    <Paper>
      <Body block style={{ padding: 8 }}>
        Nedan ser du de kontaktpersoner som finns inlagda med Roll: Attestering. Om den
        person som ska attestera denna bokning inte syns nedan, vänligen gå till
        kundprofilen och uppdatera detta. OBS: du ska inte göra något val här, detta
        vissas bara för din kännedom
      </Body>

      {query.data.attestContactPersons.items.map((item) => (
        <CustomerContactCard key={item._id} item={item} style={{ borderBottom: 0 }} />
      ))}
    </Paper>
  );
}
